import type { DatasetFormEditorWrapperProps } from "./dataset-form-editor.type";

import { DatasetFormEditor } from "./dataset-form-editor.component";

export const DatasetFormEditorWrapper = ({
  template,
  ...props
}: DatasetFormEditorWrapperProps) => {
  if (!template) return null;

  return <DatasetFormEditor {...props} template={template} />;
};
